module.exports = __webpack_public_path__ + "img/CH00-002-003.67414841.jpg";